import React from "react";
import { CircleCheck, Award, Users, Building2 } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AuthorityAndLegacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    label: "Clientes Atendidos",
    value: "+1500",
    icon: <Users className="size-5 text-primary" />
  }, {
    label: "Projetos Entregues",
    value: "+1.2k",
    icon: <Building2 className="size-5 text-primary" />
  }, {
    label: "Certificações",
    value: "ISO/ABNT",
    icon: <Award className="size-5 text-primary" />
  }];
  return <section id="autoridade-e-legado" ref={ref} className="relative overflow-hidden bg-background py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden opacity-[0.03]">
        <span className="select-none whitespace-nowrap text-[18vw] font-black leading-none text-foreground">
          DOCTORICE
        </span>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, var(--foreground) 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }}>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 lg:items-center">
          {}
          <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative overflow-hidden rounded-xl bg-muted shadow-2xl ring-1 ring-border/50">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/doctorice_industrial_facility.png" alt="Instalação industrial e equipe de engenharia da Doctorice" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              </AspectRatio>
              
              {}
              <div className="absolute bottom-6 left-6 flex items-center gap-3 rounded-lg bg-background/95 px-4 py-3 shadow-lg backdrop-blur-sm border border-border/50">
                <CircleCheck className="size-6 text-primary" />
                <div>
                  {}
                  <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Desde 1990</p>
                  <p className="text-sm font-bold text-foreground">Excelência em Engenharia</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className={`flex flex-col justify-center transition-all duration-1000 ease-out delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <h2 className="mb-6 text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">Referência em Refrigeração Industrial</h2>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                A Doctorice consolidou-se como uma autoridade no setor de engenharia térmica, oferecendo soluções que vão muito além do controle de temperatura. Com décadas de atuação no mercado brasileiro, nossa trajetória é marcada pelo compromisso inegociável com a precisão técnica e a confiabilidade operacional em ambientes onde falhas não são uma opção.
              </p>
              <p>
                Nossa expertise abrange desde o projeto conceitual até a fabricação e integração de sistemas complexos para aplicações críticas. Atuamos com rigor em setores como saúde, data centers e processos industriais, garantindo que cada equipamento entregue cumpra as mais estritas normas de desempenho e segurança.
              </p>
              <p>
                Mais do que fornecedores, somos parceiros estratégicos de engenharia. Nossa equipe técnica altamente qualificada trabalha continuamente para desenvolver inovações que assegurem eficiência energética e estabilidade, protegendo o patrimônio e as operações vitais de nossos clientes.
              </p>
            </div>

            <Separator className="my-10 bg-border" />

            {}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col gap-2">
                  <div className="mb-1 flex items-center gap-2 text-muted-foreground">
                    {stat.icon}
                    <span className="text-xs font-medium uppercase tracking-wider">{stat.label}</span>
                  </div>
                  <span className="text-2xl font-bold text-foreground sm:text-3xl">
                    {stat.value}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}